import type { GameState } from '@tentactoe/engine';
import type { Theme } from '../theme';

interface StatusProps {
  readonly state: GameState;
  readonly theme: Theme;
}

export function Status({ state, theme }: StatusProps) {
  const { classes } = theme;

  if (state.result === 'draw') {
    return (
      <div className="mb-4 text-center" role="status">
        <div className={classes.statusDraw}>It&apos;s a draw</div>
      </div>
    );
  }

  if (state.result !== null) {
    return (
      <div className="mb-4 text-center" role="status">
        <div className={classes.statusWin}>Player {state.result} wins</div>
      </div>
    );
  }

  const turnClass = state.turn === 'X' ? classes.turnX : classes.turnO;

  return (
    <div className="mb-4 text-center" role="status">
      <div className="text-xl font-semibold text-gray-700 mb-1">
        Current player: <span className={`font-bold ${turnClass}`}>{state.turn}</span>
      </div>
      <div className={classes.statusHint}>
        {state.activeBoard === null
          ? 'Play in any open board'
          : `Play in board ${state.activeBoard + 1}`}
      </div>
    </div>
  );
}
